import Loader from "./loader"
import { ClipLoader } from "react-spinners"




function CommonButton(props) {

    const {
        title,
        handlerFunction,
        isLoading, isDisabled
    } = props

    return <button className={`AddQuestion_submit_btn mx-3 ${isDisabled ? 'greyed-out-button' : ''}`} style={{ cursor: 'pointer', minWidth: '100px', minHeight: '42px' }
    }
        onClick={handlerFunction}
        disabled={isLoading || isDisabled}

    > {isLoading ? <Loader /> : title}</button >

}

export default CommonButton
